import React from 'react';
import { REGISTRY, cssUrl } from './registry';

// CMS-rendered structural preview. Product cards use representative sample imagery
// (the CMS doesn't fetch live products); banner images, titles, chips, flags come
// from the section data so the layout & content are accurate.

const N_DESKTOP = 5;
const N_MOBILE = 2;

const S3 = 'https://kickavenue-assets.s3.amazonaws.com/';
const SAMPLE = [
  { n: 'Adidas Samba OG', img: S3 + 'products/3743/c2e24aac32fefa54403acf7bd51acf0c.png' },
  { n: 'New Balance 1906R', img: S3 + 'products/73686/b95f72ec2f4f333e84cfb1a1172b0a20.png' },
  { n: 'Nike P-6000 Flat Pewter', img: S3 + 'products/72889/0946f84de963633558be283cd1ec54fa.png' },
  { n: 'Puma Palermo Leather', img: S3 + 'products/79299/115d3c7f8d2cffd1c26a93742a5f12ef.png' },
  { n: 'Adidas Samba Black Gum', img: S3 + 'products/57287/9ae5c4ebf513e7245de7d28647811a7c.png' },
  { n: 'Puma Palermo Alpine', img: S3 + 'products/108346/2080254340b69b638944fdfde2e3fe2c.png' },
];

function Cards({ n, retail, seed }) {
  const arr = [];
  for (let k = 0; k < n; k++) {
    const p = SAMPLE[(seed + k) % SAMPLE.length];
    arr.push(
      <div className="hp-card" key={k}>
        <div className="img" style={{ backgroundImage: `url('${cssUrl(p.img)}')` }} />
        <div className="nm">{p.n}</div>
        <div>
          {retail && <span style={{ textDecoration: 'line-through', color: '#c8ced3', fontSize: '.56rem', marginRight: 4 }}>retail</span>}
          <span className="pr-ph" style={retail ? { background: '#f7caca' } : {}} />
        </div>
      </div>
    );
  }
  return <div className="hp-row">{arr}</div>;
}

function Head({ s }) {
  return (
    <div>
      <div className="hp-sec-h"><span className="ti">{s.title || ''}</span><span className="va">{s.action_title || 'View All'}</span></div>
      {s.subtitle ? <div className="hp-sub">{s.subtitle}</div> : null}
    </div>
  );
}

function Banner({ s, mob }) {
  const ov = s.overlay || {};
  const cap = (ov.badge || ov.title || ov.subtitle)
    ? (<span className="cap">{ov.badge ? <span style={{ background: '#fff', color: '#222', borderRadius: 3, padding: '0 6px', fontSize: '.56rem', marginRight: 6 }}>{ov.badge}</span> : null}{ov.title || s.title || ''}{ov.subtitle ? <div style={{ fontSize: '.6rem', fontWeight: 400 }}>{ov.subtitle}</div> : null}</span>)
    : (<span className="cap">{s.title || ''}</span>);
  // Mobile toggle previews the portrait crop (fall back to desktop while a draft is half-filled).
  const img = mob ? (s.bannerImgMobile || s.bannerImg) : s.bannerImg;
  if (img) {
    return <div className="hp-banner hp-banner-img" style={{ backgroundImage: `url('${cssUrl(img)}')` }}>{cap}</div>;
  }
  return <div className="hp-banner">{s.title || 'BANNER'}</div>;
}

function block(s, mob) {
  const n = mob ? N_MOBILE : N_DESKTOP;
  const retail = !!s.show_under_retail;
  const seed = (s.title || '').length;
  switch (s.type) {
    case 'slider_banner':
      return <div className="hp-hero">HERO BANNER / SLIDER</div>;
    case 'shortcut':
      return (
        <div className="hp-shortcut">
          {['Sneakers', 'Apparels', 'Handbags', 'Lifestyle', 'Cards', 'Brands'].map((c) => (
            <div className="s" key={c}><div className="ic"><i className="fa fa-tag" /></div>{c}</div>
          ))}
        </div>
      );
    case 'brand_focus':
      return <div><Head s={s} /><div className="hp-brand">{['Nike', 'Adidas', 'NB', 'Puma', 'Asics'].map((b) => <div className="b" key={b}>{b}</div>)}</div></div>;
    case 'banner_chip_1_row':
    case 'banner_chip_2_rows': {
      const lay = s.bannerLayout || 'banner_chips';
      const rawChips = (s.chips && s.chips.length) ? s.chips : [{ name: 'All' }, { name: 'Samba' }, { name: 'Palermo' }, { name: '1906R' }];
      const chips = rawChips.map((c) => (typeof c === 'string' ? c : (c.name || '')));
      return (
        <div>
          {lay !== 'chips' ? <Banner s={s} mob={mob} /> : null}
          {lay !== 'banner' ? <div className="hp-chips">{chips.map((c, k) => <div className="c" key={k}>{c}</div>)}</div> : null}
          <Cards n={n} retail={retail} seed={seed} />
        </div>
      );
    }
    case 'banner_only':
      // No heading/overlay is published for banner_only — preview the bare banner.
      return <Banner s={Object.assign({}, s, { title: '', overlay: null })} mob={mob} />;
    case 'break_with_bg':
      return <Banner s={s} mob={mob} />;
    case 'break_without_bg': {
      const sp = (s.social && s.social.length) ? s.social : [{ number: '10K+', text: 'shipped' }, { number: '4.9', text: 'rating' }, { number: '2 hrs', text: 'avg ship' }];
      return (
        <div className="hp-stats">
          <div className="hp-stats-ic">{s.icon ? <img src={s.icon} alt="" style={{ width: 22, height: 22, objectFit: 'contain' }} /> : <i className="fa fa-bolt" />}</div>
          <div className="hp-stats-body">
            <div className="ti">{s.title || 'Express Shipping'}</div>
            <div className="hp-stats-metrics">{sp.map((m, k) => <span key={k}><b>{m.number}</b> {m.text}</span>)}</div>
          </div>
        </div>
      );
    }
    case 'promo_banner':
      return <div className="hp-banner" style={{ background: 'linear-gradient(120deg,#16a085,#1abc9c)' }}>{s.title || 'PROMO'}</div>;
    case 'row2_small_card':
    case 'row2_no_bg_card':
      return <div className={s.type.indexOf('small') !== -1 ? 'hp-cardbg' : ''}><Head s={s} /><Cards n={n} retail={retail} seed={seed} /></div>;
    default: // row1/row3 + fallthrough
      return <div className={s.type.indexOf('small') !== -1 ? 'hp-cardbg' : ''}><Head s={s} /><Cards n={n} retail={retail} seed={seed} /></div>;
  }
}

export default function Preview({ sections, indices, selected, onSelect, device, platform }) {
  if (platform === 'app') {
    return (
      <div>
        <div className="hpb-appnote"><i className="fa fa-info-circle" /> Structural preview — section order &amp; content only. The app's Flutter UI can't be rendered here, so this isn't a visual mock.</div>
        {indices.map((i) => {
          const s = sections[i];
          const r = REGISTRY[s.type] || { label: s.type, icon: 'fa-cube' };
          return (
            <div key={s._id} className="hpb-sec" role="button" tabIndex={0}
              style={selected === i ? { borderLeftColor: 'var(--hpb-primary)', background: '#f3fbfe' } : {}}
              onClick={() => onSelect(i)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelect(i); } }}>
              <div className="thumb" style={s.bannerImg ? { backgroundImage: `url('${cssUrl(s.bannerImg)}')` } : {}}>{s.bannerImg ? null : <i className={`fa ${r.icon}`} />}</div>
              <div className="meta"><div className="t">{s.title || r.label || '(untitled)'}</div><div className="ty">{r.label}</div></div>
            </div>
          );
        })}
      </div>
    );
  }
  const mob = device === 'mobile';
  return (
    <div className={`hp ${mob ? 'hp-mob' : ''}`}>
      {indices.map((i) => {
        const s = sections[i];
        return (
          <div key={s._id} className={`blk ${selected === i ? 'sel' : ''}`} role="button" tabIndex={0}
            aria-label={`Edit section: ${s.title || s.type}`}
            onClick={() => onSelect(i)}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelect(i); } }}>{block(s, mob)}</div>
        );
      })}
    </div>
  );
}
